export default "__VITE_ASSET__ux7AIqSL__"